export default "__VITE_ASSET__CvvpvG8z__"